import {Injectable, NgModule} from '@angular/core';
import {AsyncPipe, CommonModule} from '@angular/common';
import {TextFieldComponent} from './fields/text/text-field/text-field.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {CustomMatIconModule} from '@mydocma/component-library/src/lib/custom-mat-icon';
import {MydocmaFormModule} from '@mydocma/component-library/src/lib/form';
import {TranslateModule} from '@ngx-translate/core';
import {NumberFieldComponent} from './fields/number/number-field/number-field.component';
import {TextAreaFieldComponent} from './fields/textarea/text-area-field/text-area-field.component';
import {SelectFieldComponent} from './fields/select/select-field/select-field.component';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {CheckboxFieldComponent} from './fields/checkbox/checkbox-field/checkbox-field.component';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {OptionFieldComponent} from './fields/options/option-field/option-field.component';
import {MatLegacyRadioModule as MatRadioModule} from '@angular/material/legacy-radio';
import {DateFieldComponent} from './fields/date/date-field/date-field.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {ButtonFieldComponent} from './fields/button/button-field/button-field.component';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
import {DatetimeFieldComponent} from './fields/datetime/datetime-field/datetime-field.component';
import {TimeFieldComponent} from './fields/time/time-field/time-field.component';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {IconFieldComponent} from './fields/icon/icon-field/icon-field.component';
import {ImageFieldComponent} from './fields/image/image-field/image-field.component';
import {DynamicFormComponent} from './dynamic-form/dynamic-form/dynamic-form.component';
import {DynamicFieldDirective} from './dynamic-field/dynamic-field.directive';
import {DynamicFieldErrorsComponent} from './validation/dynamic-field-errors/dynamic-field-errors.component';
import {
    BaseValueAccessorFieldComponent
} from './fields/base/base-value-accessor-field/base-value-accessor-field.component';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {SlideToggleFieldComponent} from './fields/slidetoggle/slide-toggle-field/slide-toggle-field.component';
import {MatLegacySlideToggleModule as MatSlideToggleModule} from '@angular/material/legacy-slide-toggle';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {DynamicFieldAffixComponent} from './affix/dynamic-field-affix/dynamic-field-affix.component';
import {ResizeModule} from '@mydocma/component-library/src/lib/resize';
import {FieldContainerComponent} from './fields/base/field-container/field-container.component';
import {FlexLayoutComponent} from './layouts/flex-layout/flex-layout/flex-layout.component';
import {MatGridListModule} from '@angular/material/grid-list';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ListLayoutComponent} from './layouts/list-layout/list-layout.component';
import {LabelFieldComponent} from './fields/label/label-field/label-field.component';
import {FlexLayoutItemComponent} from './layouts/flex-layout/flex-layout-item/flex-layout-item.component';
import {DynamicFormAutofillService} from './autofill/dynamic-form-autofill.service';
import {AutofillComponent} from './autofill/autofill/autofill.component';
import {FilterSelectFieldComponent} from './fields/filter-select/select-field/filter-select-field.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgSelectFormFieldControlDirective} from './fields/filter-select/directives/ ng-select.directive';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {FileSelectFieldComponent} from './fields/file-select/file-select-field/file-select-field.component';
import {DragDropFileUploadModule} from '@mydocma/component-library/src/lib/drag-drop-file-upload';
import {MydocmaChipsModule} from '@mydocma/component-library/src/lib/chips';
import {ChipsFieldComponent} from './fields/chips/chips-field/chips-field.component';
import {ChipsMultiSelectFieldComponent} from './fields/chips-multiselect/chips-multiselect-field/chips-multiselect-field.component';
import {MultiOptionComponent} from './fields/multi-option/multi-option-field/multi-option.component';
import {CustomFieldComponent} from './fields/custom/custom-field/custom-field.component';
import {CustomFieldTemplateDirective} from './fields/custom/directives/custom-field-template.directive';
import {CustomFieldService} from './fields/custom/custom-field.service';
import {DividerFieldComponent} from './fields/divider/divider-field/divider-field.component';
import {MatLegacyChipsModule as MatChipsModule} from '@angular/material/legacy-chips';
import {MatIconModule} from '@angular/material/icon';
import {HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule} from '@angular/platform-browser';
import {NumberPickerComponent} from './fields/number/number-picker/number-picker.component';
import {SourceItemDirective} from './fields/filter-select/directives/source-item.directive';
import {ValueItemDirective} from './fields/filter-select/directives/value-item.directive';
import { NumberFieldInputDirective } from './fields/number/number-input.directive';
import {ButtonDirective} from './fields/button/button-directive';
import {CurrencyInputDirective} from './fields/number/currency-input.directive';
import {ButtonToggleComponent} from './fields/button-toggle/button-toggle-field/button-toggle.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {
    MatButtonToggleValueAccessor
} from './fields/button-toggle/mat-button-toggle.directive';
import {HintComponent} from './hint-text/hint.component';
import {FilterSelectDropdownComponent} from './fields/filter-select/dropdown-popup/filter-select-dropdown.component';
import {SignatureFieldComponent} from './fields/signature/signature-field/signature-field.component';
import {SignatureEditorModule} from '@mydocma/component-library';
import {MydocmaPromptDialogModule} from "@mydocma/component-library/src/lib/prompt-dialog";
import {TimeFieldInputDirective} from './fields/time/time-input.directive';
import {MydocmaHighlightModule} from '@mydocma/component-library/src/lib/highlight';
import { TextAutocompletePanelComponent } from '../public-api';
import { ChipsMultiselectFieldDirective } from './fields/chips-multiselect/directives/chips-multiselect-field.directive';







@NgModule({
    declarations: [
        AutofillComponent,
        BaseValueAccessorFieldComponent,
        ButtonFieldComponent,
        CheckboxFieldComponent,
        CustomFieldComponent,
        CustomFieldTemplateDirective,
        DateFieldComponent,
        DatetimeFieldComponent,
        DynamicFieldDirective,
        DynamicFieldAffixComponent,
        DynamicFieldErrorsComponent,
        DynamicFormComponent,
        FieldContainerComponent,
        FileSelectFieldComponent,
        FilterSelectFieldComponent,
        FlexLayoutComponent,
        FlexLayoutItemComponent,
        IconFieldComponent,
        ImageFieldComponent,
        LabelFieldComponent,
        ListLayoutComponent,
        NumberFieldComponent,
        OptionFieldComponent,
        SelectFieldComponent,
        SlideToggleFieldComponent,
        TextFieldComponent,
        TextAreaFieldComponent,
        TimeFieldComponent,
        ChipsFieldComponent,
        ChipsMultiSelectFieldComponent,
        NgSelectFormFieldControlDirective,
        ChipsMultiselectFieldDirective,
        MultiOptionComponent,
        DividerFieldComponent,
        NumberPickerComponent,
        SourceItemDirective,
        ValueItemDirective,
        NumberFieldInputDirective,
        ButtonDirective,
        CurrencyInputDirective,
        ButtonToggleComponent,
        MatButtonToggleValueAccessor,
        HintComponent,
        FilterSelectDropdownComponent,
        SignatureFieldComponent,
        TimeFieldInputDirective,
        TextAutocompletePanelComponent
    ],
    imports: [
        CommonModule,
        CustomMatIconModule,
        DragDropFileUploadModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MydocmaChipsModule,
        MydocmaFormModule,
        NgSelectModule,
        NgxMatDatetimePickerModule,
        NgxMaterialTimepickerModule,
        NgxMatNativeDateModule,
        NgxMatTimepickerModule,
        ReactiveFormsModule,
        ResizeModule,
        TranslateModule,
        //  _MatMenuDirectivesModule, MIG13
        MatMenuModule,
        HammerModule,
        MatButtonToggleModule,
        SignatureEditorModule,
        MydocmaHighlightModule
    ],
    exports: [
        AutofillComponent,
        BaseValueAccessorFieldComponent,
        ButtonFieldComponent,
        CheckboxFieldComponent,
        CustomFieldComponent,
        CustomFieldTemplateDirective,
        CustomMatIconModule,
        DateFieldComponent,
        DynamicFieldAffixComponent,
        DynamicFieldDirective,
        DynamicFormComponent,
        FileSelectFieldComponent,
        IconFieldComponent,
        ImageFieldComponent,
        LabelFieldComponent,
        MydocmaFormModule,
        NgSelectModule,
        NgSelectFormFieldControlDirective,
        NumberFieldComponent,
        OptionFieldComponent,
        ReactiveFormsModule,
        SelectFieldComponent,
        TextAreaFieldComponent,
        TextFieldComponent,
        NumberPickerComponent,
        TextAutocompletePanelComponent
    ],
    providers: [
        DynamicFormAutofillService,
        CustomFieldService,
        AsyncPipe,

    ]
})
export class MydocmaDynamicFormModule {
}
